module.exports = __webpack_public_path__ + "media-academy-infographic.bc2209c058ab89878152d8c253ace7d3.png";